import React from 'react'
import { Head } from '../../../Components/Typography/Text.styles'
import { VERIFIED_YEAR } from '../../../Config/League/league.config'
import { VerifiedSection } from './components/VerifiedSection'
import { VerifiedOuter } from './components/styles'

const AcademyVerified: React.FC = () => {
  return (
    <VerifiedOuter>
      <Head>Proud Partners of PLL Verified {VERIFIED_YEAR}</Head>
      <VerifiedSection />
    </VerifiedOuter>
  )
}
export default AcademyVerified
